const WhitePlusIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.8027 5V19M5.80273 12H19.8027"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ErrorInfoIcon = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99992 11.8335C8.18881 11.8335 8.34725 11.7695 8.47525 11.6415C8.60325 11.5135 8.66703 11.3553 8.66659 11.1668C8.66614 10.9784 8.60214 10.8202 8.47459 10.6922C8.34703 10.5642 8.18881 10.5002 7.99992 10.5002C7.81103 10.5002 7.65281 10.5642 7.52525 10.6922C7.3977 10.8202 7.3337 10.9784 7.33325 11.1668C7.33281 11.3553 7.39681 11.5137 7.52525 11.6422C7.6537 11.7706 7.81192 11.8344 7.99992 11.8335ZM7.33325 9.16683H8.66659V5.16683H7.33325V9.16683ZM7.99992 15.1668C7.0777 15.1668 6.21103 14.9917 5.39992 14.6415C4.58881 14.2913 3.88325 13.8164 3.28325 13.2168C2.68325 12.6173 2.20836 11.9117 1.85859 11.1002C1.50881 10.2886 1.3337 9.42194 1.33325 8.50016C1.33281 7.57838 1.50792 6.71172 1.85859 5.90016C2.20925 5.08861 2.68414 4.38305 3.28325 3.7835C3.88236 3.18394 4.58792 2.70905 5.39992 2.35883C6.21192 2.00861 7.07859 1.8335 7.99992 1.8335C8.92125 1.8335 9.78792 2.00861 10.5999 2.35883C11.4119 2.70905 12.1175 3.18394 12.7166 3.7835C13.3157 4.38305 13.7908 5.08861 14.1419 5.90016C14.493 6.71172 14.6679 7.57838 14.6666 8.50016C14.6653 9.42194 14.4901 10.2886 14.1413 11.1002C13.7924 11.9117 13.3175 12.6173 12.7166 13.2168C12.1157 13.8164 11.4101 14.2915 10.5999 14.6422C9.7897 14.9928 8.92303 15.1677 7.99992 15.1668Z"
      fill="#FF3B30"
    />
  </svg>
);

const SendIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.8025 2L11.8025 13M22.8025 2L15.8025 22L11.8025 13M22.8025 2L2.80249 9L11.8025 13"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EmptyNotes = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M46.3792 65.0125C47.6792 66.3125 49.7792 66.3125 51.0792 65.0125L57.3459 58.7125L63.6459 65.0125C64.9459 66.3125 67.0459 66.3125 68.3459 65.0125C69.6459 63.7125 69.6459 61.6125 68.3459 60.3125L62.0459 54.0125L68.3459 47.7125C69.6459 46.4125 69.6459 44.3125 68.3459 43.0125C67.0459 41.7125 64.9459 41.7125 63.6459 43.0125L57.3459 49.3125L51.0459 43.0125C49.7459 41.7125 47.6459 41.7125 46.3459 43.0125C45.0459 44.3125 45.0459 46.4125 46.3459 47.7125L52.6459 54.0125L46.3459 60.3125C45.0792 61.5792 45.0792 63.7125 46.3792 65.0125ZM47.3459 30.6792C47.3459 28.8458 45.8459 27.3458 44.0125 27.3458H14.0125C12.1792 27.3458 10.6792 28.8458 10.6792 30.6792C10.6792 32.5125 12.1792 34.0125 14.0125 34.0125H44.0125C45.8459 34.0125 47.3459 32.5125 47.3459 30.6792ZM47.3459 17.3458C47.3459 15.5125 45.8459 14.0125 44.0125 14.0125H14.0125C12.1792 14.0125 10.6792 15.5125 10.6792 17.3458C10.6792 19.1792 12.1792 20.6792 14.0125 20.6792H44.0125C45.8459 20.6792 47.3459 19.1792 47.3459 17.3458ZM10.6792 44.0125C10.6792 45.8458 12.1792 47.3458 14.0125 47.3458H30.6792C32.5125 47.3458 34.0125 45.8458 34.0125 44.0125C34.0125 42.1792 32.5125 40.6792 30.6792 40.6792H14.0125C12.1792 40.6792 10.6792 42.1792 10.6792 44.0125Z"
      fill="#9D25DC"
    />
  </svg>
);

const VisaLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 192.756 192.756">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#fff"
      fillOpacity="0"
      d="M0 0h192.756v192.756H0V0z"
    />
    <path fill="#1d5b99" d="M181.266 155.531H8.504V37.225h175.748V155.531h-2.986z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#fff"
      d="M181.266 152.545H11.49V40.211h169.776v112.334z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#1d5b99"
      d="M72.851 114.621l11.026-36.355h9.838l-11.027 36.355h-9.837zM68.453 78.276l-8.85 15.412c-2.252 4.037-3.57 6.076-4.203 8.625h-.135c.157-3.232-.294-7.203-.336-9.447l-.978-14.59h-16.56l-.169.978c4.254 0 6.777 2.137 7.471 6.509l3.228 28.858h10.192l20.609-36.345H68.453zM144.959 114.621l-.271-5.406-12.283-.01-2.514 5.416h-10.68l19.367-36.286h13.109l3.279 36.286h-10.007zm-1.127-21.445c-.111-2.687-.201-6.333-.02-8.541h-.145c-.598 1.805-3.17 7.225-4.301 9.89l-3.66 7.968h8.625l-.499-9.317zM104.043 115.654c-6.945 0-11.555-2.203-14.845-4.168l4.686-7.156c2.955 1.652 5.274 3.559 10.612 3.559 1.715 0 3.369-.445 4.309-2.072 1.367-2.363-.316-3.637-4.158-5.812l-1.898-1.234c-5.697-3.892-8.162-7.59-5.48-14.044 1.717-4.128 6.242-7.258 13.711-7.258 5.148 0 9.977 2.228 12.789 4.404l-5.387 6.318c-2.746-2.22-5.021-3.343-7.625-3.343-2.076 0-3.654.801-4.199 1.881-1.025 2.03.332 3.414 3.326 5.272l2.256 1.436c6.918 4.363 8.564 8.937 6.832 13.212-2.984 7.363-8.822 9.005-14.929 9.005zM157.895 83.193h-.426v-2.594h.984c.627 0 .945.219.945.746 0 .47-.287.665-.676.708l.727 1.14h-.482l-.67-1.108h-.402v1.108zm.476-1.473c.32 0 .602-.031.602-.407 0-.313-.307-.351-.562-.351h-.516v.758h.476zm-.012 2.476c-1.348 0-2.307-1.009-2.307-2.344 0-1.409 1.064-2.343 2.307-2.343 1.227 0 2.293.934 2.293 2.343 0 1.41-1.066 2.344-2.293 2.344zm0-4.28c-1.016 0-1.805.796-1.805 1.936 0 1.065.689 1.936 1.805 1.936 1.002 0 1.791-.79 1.791-1.936 0-1.14-.789-1.936-1.791-1.936z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#e7a83a"
      d="M177.086 125.912H15.969v21.557h161.117v-21.557z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#1d5b99"
      d="M176.787 45.586H15.671v21.558h161.116V45.586zM173.105 145.936h-.426v-2.594h.984c.627 0 .945.219.945.746 0 .469-.287.664-.676.707l.727 1.141h-.482l-.67-1.109h-.402v1.109zm.477-1.473c.32 0 .602-.031.602-.408 0-.312-.307-.35-.562-.35h-.516v.758h.476zm-.012 2.475c-1.348 0-2.307-1.008-2.307-2.344 0-1.408 1.066-2.342 2.307-2.342 1.229 0 2.293.934 2.293 2.342 0 1.41-1.064 2.344-2.293 2.344zm0-4.28c-1.016 0-1.805.797-1.805 1.936 0 1.066.689 1.936 1.805 1.936 1.002 0 1.791-.789 1.791-1.936 0-1.139-.789-1.936-1.791-1.936z"
    />
  </svg>
);

const MasterCardLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 143 88.78">
    <title>Mastercard logo</title>
    <polygon
      points="52.16 79.29 90.83 79.29 90.83 9.49 52.16 9.49 52.16 79.29"
      style={{ fill: '#ff5f00' }}
    />
    <path
      d="M495.12,512A44.38,44.38,0,0,1,512,477.1a44.39,44.39,0,1,0,0,69.8A44.39,44.39,0,0,1,495.12,512"
      transform="translate(-440.5 -467.61)"
      style={{ fill: '#eb001b' }}
    />
    <path
      d="M583.5,512A44.15,44.15,0,0,1,512,546.9a44.52,44.52,0,0,0,0-69.8A44.15,44.15,0,0,1,583.5,512Z"
      transform="translate(-440.5 -467.61)"
      style={{ fill: '#f79e1b' }}
    />
  </svg>
);
const BlockSquareIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 7.5L12.5 12.5M12.5 7.5L7.5 12.5M4.16667 2.5H15.8333C16.7538 2.5 17.5 3.24619 17.5 4.16667V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5Z"
        stroke="#9D25DC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const SyncIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 3C8.03 3 4 7.03 4 12H1L4.89 15.89L4.96 16.03L9 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.07 19 9.32 18.21 8.06 16.94L6.64 18.36C8.27 19.99 10.51 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.28 15.54L17 14.33L13.5 12.25V8H12Z"
      fill="#9D25DC"
    />
  </svg>
);

const ShortArrowIcon = () => (
  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 1.5L6 6.5L11 1.5"
      stroke="#9D25DC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckMarkIcon = () => (
  <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 5.35075L5.07462 8.42537L11.5 2"
      stroke="white"
      strokeWidth="2.19403"
      strokeLinecap="round"
    />
  </svg>
);

const MenuIcon = () => (
  <svg width="19" height="5" viewBox="0 0 19 5" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.66663 3.5C10.2189 3.5 10.6666 3.05228 10.6666 2.5C10.6666 1.94772 10.2189 1.5 9.66663 1.5C9.11434 1.5 8.66663 1.94772 8.66663 2.5C8.66663 3.05228 9.11434 3.5 9.66663 3.5Z"
      stroke="#9D25DC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6666 3.5C17.2189 3.5 17.6666 3.05228 17.6666 2.5C17.6666 1.94772 17.2189 1.5 16.6666 1.5C16.1143 1.5 15.6666 1.94772 15.6666 2.5C15.6666 3.05228 16.1143 3.5 16.6666 3.5Z"
      stroke="#9D25DC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66663 3.5C3.21891 3.5 3.66663 3.05228 3.66663 2.5C3.66663 1.94772 3.21891 1.5 2.66663 1.5C2.11434 1.5 1.66663 1.94772 1.66663 2.5C1.66663 3.05228 2.11434 3.5 2.66663 3.5Z"
      stroke="#9D25DC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BigGreenCheckIcon = () => (
  <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.5 2.625C12.2502 2.625 10.051 3.29213 8.18039 4.54203C6.30978 5.79193 4.85182 7.56847 3.99088 9.64698C3.12993 11.7255 2.90467 14.0126 3.34357 16.2192C3.78248 18.4257 4.86584 20.4525 6.45667 22.0433C8.04749 23.6342 10.0743 24.7175 12.2809 25.1564C14.4874 25.5953 16.7745 25.3701 18.853 24.5091C20.9315 23.6482 22.7081 22.1902 23.958 20.3196C25.2079 18.449 25.875 16.2498 25.875 14C25.8718 10.9841 24.6724 8.09271 22.5398 5.96018C20.4073 3.82764 17.5159 2.62818 14.5 2.625ZM19.4941 11.9941L13.3691 18.1191C13.2878 18.2004 13.1913 18.265 13.0851 18.309C12.9789 18.353 12.865 18.3757 12.75 18.3757C12.635 18.3757 12.5212 18.353 12.4149 18.309C12.3087 18.265 12.2122 18.2004 12.1309 18.1191L9.50594 15.4941C9.34176 15.3299 9.24952 15.1072 9.24952 14.875C9.24952 14.6428 9.34176 14.4201 9.50594 14.2559C9.67013 14.0918 9.89281 13.9995 10.125 13.9995C10.3572 13.9995 10.5799 14.0918 10.7441 14.2559L12.75 16.263L18.2559 10.7559C18.3372 10.6746 18.4338 10.6102 18.54 10.5662C18.6462 10.5222 18.76 10.4995 18.875 10.4995C18.99 10.4995 19.1038 10.5222 19.21 10.5662C19.3163 10.6102 19.4128 10.6746 19.4941 10.7559C19.5754 10.8372 19.6399 10.9337 19.6838 11.04C19.7278 11.1462 19.7505 11.26 19.7505 11.375C19.7505 11.49 19.7278 11.6038 19.6838 11.71C19.6399 11.8163 19.5754 11.9128 19.4941 11.9941Z"
      fill="#34C759"
    />
  </svg>
);

const PastIconWithArrow = () => (
  <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 0C9.37333 0 4 5.37333 4 12H0L5.18667 17.1867L5.28 17.3733L10.6667 12H6.66667C6.66667 6.84 10.84 2.66667 16 2.66667C21.16 2.66667 25.3333 6.84 25.3333 12C25.3333 17.16 21.16 21.3333 16 21.3333C13.4267 21.3333 11.0933 20.28 9.41333 18.5867L7.52 20.48C9.69333 22.6533 12.68 24 16 24C22.6267 24 28 18.6267 28 12C28 5.37333 22.6267 0 16 0ZM14.6667 6.66667V13.3333L20.3733 16.72L21.3333 15.1067L16.6667 12.3333V6.66667H14.6667Z"
      fill="#9D25DC"
    />
  </svg>
);

const FlagIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15ZM4 15V22"
      stroke="#9D25DC"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ExternalLinkIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 7.66667V11.6667C11 12.0203 10.8595 12.3594 10.6095 12.6095C10.3594 12.8595 10.0203 13 9.66667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V4.33333C1 3.97971 1.14048 3.64057 1.39052 3.39052C1.64057 3.14048 1.97971 3 2.33333 3H6.33333M9 1H13M13 1V5M13 1L5.66667 8.33333"
      stroke="#9D25DC"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TicketIcon = () => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 1V3M13 7V9M13 13V15M3 1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V6C18.4696 6 17.9609 6.21071 17.5858 6.58579C17.2107 6.96086 17 7.46957 17 8C17 8.53043 17.2107 9.03914 17.5858 9.41421C17.9609 9.78929 18.4696 10 19 10V13C19 13.5304 18.7893 14.0391 18.4142 14.4142C18.0391 14.7893 17.5304 15 17 15H3C2.46957 15 1.96086 14.7893 1.58579 14.4142C1.21071 14.0391 1 13.5304 1 13V10C1.53043 10 2.03914 9.78929 2.41421 9.41421C2.78929 9.03914 3 8.53043 3 8C3 7.46957 2.78929 6.96086 2.41421 6.58579C2.03914 6.21071 1.53043 6 1 6V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1Z"
      stroke="white"
      strokeWidth="1.44"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EyeIcon = () => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.833008 8.00016C0.833008 8.00016 4.16634 1.3335 9.99967 1.3335C15.833 1.3335 19.1663 8.00016 19.1663 8.00016C19.1663 8.00016 15.833 14.6668 9.99967 14.6668C4.16634 14.6668 0.833008 8.00016 0.833008 8.00016Z"
      stroke="#9D25DC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99967 10.5002C11.3804 10.5002 12.4997 9.38087 12.4997 8.00016C12.4997 6.61945 11.3804 5.50016 9.99967 5.50016C8.61896 5.50016 7.49967 6.61945 7.49967 8.00016C7.49967 9.38087 8.61896 10.5002 9.99967 10.5002Z"
      stroke="#9D25DC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DownloadIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 11.5V14.8333C16.5 15.2754 16.3244 15.6993 16.0118 16.0118C15.6993 16.3244 15.2754 16.5 14.8333 16.5H3.16667C2.72464 16.5 2.30072 16.3244 1.98816 16.0118C1.67559 15.6993 1.5 15.2754 1.5 14.8333V11.5M4.83333 7.33333L9 11.5M9 11.5L13.1667 7.33333M9 11.5V1.5"
      stroke="#9D25DC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TrashIcon = () => (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.69751 5.00002H3.36418M3.36418 5.00002H16.6975M3.36418 5.00002L3.36418 16.6667C3.36418 17.1087 3.53977 17.5326 3.85233 17.8452C4.16489 18.1578 4.58882 18.3334 5.03084 18.3334H13.3642C13.8062 18.3334 14.2301 18.1578 14.5427 17.8452C14.8552 17.5326 15.0308 17.1087 15.0308 16.6667V5.00002M5.86418 5.00002V3.33335C5.86418 2.89133 6.03977 2.4674 6.35233 2.15484C6.66489 1.84228 7.08882 1.66669 7.53084 1.66669H10.8642C11.3062 1.66669 11.7301 1.84228 12.0427 2.15484C12.3552 2.4674 12.5308 2.89133 12.5308 3.33335V5.00002M7.53084 9.16669V14.1667M10.8642 9.16669V14.1667"
      stroke="#DC2525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LoadingIcon = ({ fillColor = 'white' }) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3_717)">
      <path
        d="M10.1976 2.16667V5.50001M10.1976 15.5V18.8333M4.30592 4.60834L6.66426 6.96667M13.7309 14.0333L16.0893 16.3917M1.86426 10.5H5.19759M15.1976 10.5H18.5309M4.30592 16.3917L6.66426 14.0333M13.7309 6.96667L16.0893 4.60834"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_717">
        <rect width="20" height="20" fill={fillColor} transform="translate(0.19751 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export {
  ExternalLinkIcon,
  WhitePlusIcon,
  ErrorInfoIcon,
  SendIcon,
  EmptyNotes,
  VisaLogo,
  MasterCardLogo,
  BlockSquareIcon,
  SyncIcon,
  ShortArrowIcon,
  CheckMarkIcon,
  MenuIcon,
  BigGreenCheckIcon,
  PastIconWithArrow,
  FlagIcon,
  TicketIcon,
  EyeIcon,
  DownloadIcon,
  TrashIcon,
  LoadingIcon,
};
